import numeral from "numeral";
import React, { useEffect } from "react";
import { Grid, makeStyles, setLocale, StackedBarChart } from "../../../";
import { StackedGroupBarChart } from "../../../Molecules/Charts/StackedGroupBarChart";
import { BoxNumber } from "../../../Molecules/Dashboard/BoxNumber";
var useStyles = makeStyles(function (theme) {
  return {
    boxContainer: {
      display: "flex",
      padding: "20px 0",
      "align-items": "flex-end"
    },
    charts: {
      // display: "flex",
      "justify-content": "space-between",
      padding: "25px"
    },
    justifiySpaceBetween: {
      "justify-content": "space-between"
    },
    chartContainer: {
      margin: "20px",
      background: "#e8e8e81a",
      "align-items": "center",
      "justify-content": "space-between",
      "padding-top": "40px" // display: "flex",

    }
  };
});

var FranchiseData = function FranchiseData(_ref) {
  var dashboard = _ref.dashboard,
      compareDashboard = _ref.compareDashboard,
      country = _ref.country,
      compareYears = _ref.compareYears,
      years = _ref.years;
  // console.log("FranchiseData dashboard", dashboard);
  // console.log("FranchiseData country", country);
  // console.log("FranchiseData dcountry", dashboard[country]);
  var classes = useStyles(); // useEffect(() => {
  //   setLocale(country);
  // }, [country]);

  var createGMVCompare = function createGMVCompare() {
    console.log("test,", compareDashboard[country]);
    var numItems = Object.keys(compareDashboard[country]).filter(function (key) {
      return key.includes("gmv_");
    }).filter(function (key) {
      return years.includes(key.split("_")[1]);
    });
    numItems.sort();
    return numItems.map(function (item, index, arr) {
      return /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12 / numItems.length
      }, /*#__PURE__*/React.createElement(BoxNumber, {
        total: true,
        variant: index > 0 ? "percentage" : null,
        percentage: numeral((compareDashboard[country][item] - compareDashboard[country][arr[0]]) / compareDashboard[country][arr[0]] * 100).format("0"),
        value: compareDashboard[country][item],
        title: "GTV Total ".concat(item.split("_")[1]),
        locale: country === "ALL" ? "ES" : country
      }));
    });
  };

  return dashboard && dashboard[country] ? /*#__PURE__*/React.createElement(React.Fragment, null, country !== "all" && dashboard[country].gmv && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12,
    className: [classes.charts, classes.chartContainer].join(" ")
  }, compareYears ? compareDashboard && compareDashboard[country] && /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, createGMVCompare()) : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(BoxNumber, {
    total: true,
    value: dashboard[country].gmv,
    title: "GTV Total",
    locale: "ALL"
  })), dashboard && dashboard[country] && dashboard[country].invoices && !compareYears && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(StackedBarChart, {
    height: 370,
    dataRaw: dashboard[country].invoices,
    acc: "subtotal",
    stackedBy: "category" // brush
    ,
    label: true,
    legend: true,
    locale: "ES"
  })), compareDashboard && compareDashboard[country] && compareDashboard[country].invoices && compareYears && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(StackedGroupBarChart, {
    key: years.join("_"),
    height: 370,
    dataRaw: compareDashboard[country].invoices,
    acc: "subtotal",
    stackedBy: "dateCategory",
    groups: years // brush
    ,
    label: true,
    legend: true,
    locale: "ES"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12,
    className: [classes.boxContainer, classes.justifiySpaceBetween].join(" ")
  }, dashboard && dashboard[country] && /*#__PURE__*/React.createElement(React.Fragment, null))) : null;
};

export { FranchiseData };